import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./custom-modal-v1.css";

interface Props {
  isOpen: boolean;
  children: React.ReactNode;
  handleClose?: () => void;
  className?: string;
  closeOnBackdrop?: boolean;
}

/**
 * Refcounted, because modals stack: a flow modal stays mounted while a loading or error overlay
 * opens above it. With a per-instance save/restore the two unwind in tree order — the outer
 * restores "", then the overlay restores the "hidden" it captured — and the page is left
 * permanently unscrollable with nothing on screen. Mirrors issuerApp's CustomModal.
 */
let scrollLockCount = 0;
let scrollLockPrevOverflow = "";

function lockBodyScroll() {
  if (scrollLockCount === 0) {
    scrollLockPrevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  scrollLockCount++;
}

function unlockBodyScroll() {
  scrollLockCount = Math.max(0, scrollLockCount - 1);
  if (scrollLockCount === 0) {
    document.body.style.overflow = scrollLockPrevOverflow;
  }
}

function CustomModalV1({
  isOpen,
  children,
  handleClose,
  className = "",
  closeOnBackdrop = false,
}: Props) {
  useEffect(() => {
    if (!isOpen) return;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="v1-modal-overlay"
      onClick={closeOnBackdrop ? handleClose : undefined}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`v1-modal-box${className ? ` ${className}` : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}

export default CustomModalV1;
